function initCarousel() {
    $('.carousel-container').not('.slick-initialized').slick({
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '0px',
        responsive: [
            {
                breakpoint: 1184,
                settings: {
                    centerPadding: '0px'
                }
            },
            {
                breakpoint: 800,
                settings: {
                    centerPadding: '0px'
                }
            },
            {
                breakpoint: 650,
                settings: {
                    centerPadding: '0px'
                }
            }
        ]
    });
}

$(document).ready(function () {
    initCarousel();
});
